import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=7119a694&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=ts&"
export * from "./Deal.vue?vue&type=script&lang=ts&"
import style0 from "./Deal.vue?vue&type=style&index=0&id=7119a694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119a694",
  null
  
)

export default component.exports